<span [ngClass]="baseClass + '--text'"
      class="grow shrink text-xl md:text-base app-ellipsis mr-2 md:text-center">
    <span class="sr-only">{{ tariffSize }}</span> {{ textContent }}
    <ng-content />
</span>
<span [ngClass]="baseClass + '--price'"
      class="md:hidden border-r-2 border-grey pr-4 mr-4">
  <span class="block text-2xl font-bold text-nowrap">
    {{ priceContent }}
  </span>
  <span class="block text-sm">
    im Monat
  </span>
</span>
<span
    [ngClass]="baseClass + '--icon'"
    class="flex w-10 h-10 md:w-6 md:h-6 rounded-full bg-primary md:bg-secondary group-hover:bg-white justify-center items-center ml-2 shrink-0">
   <mat-icon
       aria-hidden="false"
       aria-label="Icon"
       class="!block !h-12 !w-auto !max-w-12 md:!h-4 md:!w-auto md:!max-w-4 text-base"
       svgIcon="right_arrow" />
  </span>
@if (tariffSize === topsellerTariff) {
    <span [ngClass]="baseClass + '--topseller-text'"
          class="rounded-full text-md font-semibold block md:hidden py-1 px-4 bg-[#0070f5] text-primary-contrast">
    {{ topsellerText }}
  </span>
}
